import React, { Component } from "react"
import IncidentTimelineTypes from "../../../../Types/IncidentTimelineTypes"
import { FormControl, OverlayTrigger, Popover, Spinner, Tooltip } from "react-bootstrap"
import moment from "moment"
import ReferenceTypes from "../../../../Types/ReferenceTypes"
import reggie from "../../../../../../utilities/Reggie"
import IconBuilder from "../../../../../../utilities/iconBuilder/IconBuilder"
import IncidentTimelineTextEditor from "./IncidentTimelineTextEditor/IncidentTimelineTextEditor"
import dompurify from "dompurify"
import DocViewer from "../../../../HRUtilities/DocViewer/DocViewer"
import DocUploader from "../../../../HRUtilities/DocUploader/DocUploader"
import TimelineViewer from "./IncidentTimelineViewer/IncidentTimelineViewer"
import DeleteIncidentTimelineItem from "./DeleteIncidentTimelineItem/DeleteIncidentTimelineItem"
import "./IncidentTimeline.css"

interface Props {
    WorkersCompensationIncidentId: number
    incidentUserId: string | number
    timelineItems: Array<IncidentTimelineTypes>
    reference: ReferenceTypes
    loadingTimeline: boolean
    timeFormat: string
    toggleLarge: Function
    isModal: boolean
    contextUser: string | number
    refreshTimeline: Function
    updateTimeLineItems: Function
    readOnly: boolean
}

interface State {
    input: string
    showActivity: boolean
    largeView: boolean
    uploadDocument: boolean
    viewDocument: boolean
    addEvent: boolean
    IncidentTimelineTypeId: number
    ascending: boolean
    editIndex: string
    delete: boolean
    edit: boolean
    openItem: IncidentTimelineTypes | null
}

class IncidentTimeline extends Component<Props, State> {

    longDateFormat = "lll"
    copy: Array<IncidentTimelineTypes> = []
    storageLocation = process.env.REACT_APP_WORK_COMP_INCIDENT_STORAGE_LOCATION || ""
    containerName = process.env.REACT_APP_WORK_COMP_INCIDENT_CONTAINER_NAME || ""
    fileStoreLocationId = process.env.REACT_APP_WORK_COMP_INCIDENT_IMAGE_FILE_STORE_LOCATION_ID || ""

    state = {
        input: "",
        showActivity: true,
        largeView: true,
        uploadDocument: false,
        viewDocument: true,
        addEvent: false,
        IncidentTimelineTypeId: -1,
        ascending: true,
        editIndex: "-1",
        delete: false,
        edit: false,
        openItem: null
    }

    handleChange = (event: { target: { value: string } }) => {
        this.setState({ input: event.target.value })
    }

    filter = (input: string, timelineItems: Array<IncidentTimelineTypes>) => {
        let temp = []
        for (let i = 0; i < timelineItems.length; i++) {
            let str = Object.values(timelineItems[i]).join().toLowerCase()
            if (str.includes(input.toLowerCase())) {
                temp.push(timelineItems[i])
            }
        }
        return temp
    }

    clearInput = () => {
        this.setState({ input: "" })
    }


    manageState = (keys: Array<{ key: string, value?: any }>) => {
        let state: any = this.state
        for (let i = 0; i < keys.length; i++) {
            if (Object.entries(keys[i]).length > 1) {
                state[keys[i].key] = keys[i].value
            } else {
                state[keys[i].key] = !state[keys[i].key]
            }
        }
        this.setState(state)
    }

    sortTimelineItems = (items: Array<any>) => {
        if (this.state.ascending) {
            return items.sort((a: any, b: any) => (a.IncidentTimelineId < b.IncidentTimelineId) ? 1 : -1)
        } else {
            return items.sort((a: any, b: any) => (a.IncidentTimelineId > b.IncidentTimelineId) ? 1 : -1)
        }
    }

    toggleOpenTimelineItem = (timelineItem: IncidentTimelineTypes | null) => {
        if (this.state.openItem) {
            this.setState({ openItem: null })
        } else {
            this.setState({ openItem: timelineItem })
        }
    }

    getFileTitle = (title: string | null) => {
        if (title) {
            let arr = title.split("_")
            return arr.slice(1, -1).join("_")
        }
        return "NA"
    }

    render() {

        const date = new Date();
        const offset = -date.getTimezoneOffset();
        const readOnly = this.props.readOnly
        let timelineItems: Array<IncidentTimelineTypes> = this.sortTimelineItems(this.props.timelineItems)
        const openItem = this.state.openItem
        const temp = JSON.parse(JSON.stringify(this.props.timelineItems))
        // //console.log("Props: ", this.props)

        for (let i = 0; i < timelineItems.length; i++) {
            timelineItems[i].IncidentTimelineTypeDesc = reggie.joinString(timelineItems[i].IncidentTimelineTypeDesc.toLowerCase())
            if (timelineItems[i].IncidentTimelineTypeId === 1) {
                //@ts-ignore
                timelineItems[i].extension = reggie.getFileExtensionFromString(timelineItems[i].FileName)
            }
        }

        if (this.state.input !== "") {
            timelineItems = this.filter(this.state.input, temp)
        }

        const TimelineToolTip = (text: string) => (
            <Tooltip id="timeline-tool-tip" >
                {text}
            </Tooltip>
        )

        const TimelinePopover = (text: string) => (
            <Popover id="timeline-popover">
                <Popover.Content>
                    <span dangerouslySetInnerHTML={{ __html: dompurify.sanitize(text) }} />
                </Popover.Content>
            </Popover>
        )


        return (
            <div className="Timeline" id={`timeline-large-view-${this.state.largeView}`}>
                {timelineItems.length > 0 && <div className="TimelineControls" id={`timeline-controls-modal-${this.props.isModal}`}>
                    <div className="WorkersCompViewTypeToggle">
                        <div id={`timeline-show-activity-wrapper-modal-${this.props.isModal}`} onClick={() => this.manageState([{ key: "showActivity" }])}>
                            <p>Show Activity</p>
                            {this.state.showActivity && <div className="WorkersCompViewTypeToggleChecked"></div>}
                            {!this.state.showActivity && <div className="WorkersCompViewTypeToggleUnchecked"></div>}
                        </div>
                    </div>
                    <div className="TimelineFilter">
                        <div className="TimelineFilterIcons" id={`timeline-filter-icons-modal-${this.props.isModal}`}>
                            {this.state.input === "" && <span className="material-icons">filter_alt</span>}
                            {this.state.input !== "" && <span className="material-icons" onClick={() => this.clearInput()}>close</span>}
                        </div>
                        <FormControl
                            placeholder={"Search Timeline"}
                            aria-describedby="basic-addon1"
                            onChange={this.handleChange}
                            value={this.state.input}
                        />
                    </div>
                </div>}
                {!this.props.loadingTimeline && !readOnly && <div className="TimelineAddButtonsWrapper" id={`timeline-add-btns-wrapper-modal-${this.props.isModal}`}>
                    <div className="TimelineAddButtons">
                        <div className="TimelineAddBtn" onClick={() => this.manageState([{ key: "uploadDocument" }])}>
                            <span className="material-icons">description</span>
                            <p>Upload Files</p>
                        </div>
                        <div className="TimelineAddBtn" onClick={() => this.manageState([{ key: "IncidentTimelineTypeId", value: 2 }, { key: "addEvent" }])}>
                            <span className="material-icons">email</span>
                            <p>Add Correspondence</p>
                        </div>
                        <div className="TimelineAddBtn" onClick={() => this.manageState([{ key: "IncidentTimelineTypeId", value: 3 }, { key: "addEvent" }])}>
                            <span className="material-icons">chat</span>
                            <p>Add Note</p>
                        </div>
                        <div className="TimelineAddBtn" onClick={() => this.manageState([{ key: "IncidentTimelineTypeId", value: 4 }, { key: "addEvent" }])}>
                            <span className="material-icons">event</span>
                            <p>Add Event</p>
                        </div>
                        <div className="TimelineAddBtn" onClick={() => this.manageState([{ key: "IncidentTimelineTypeId", value: 5 }, { key: "addForm" }])}>
                            <span className="material-icons">dynamic_feed</span>
                            <p>Add Form</p>
                        </div>
                    </div>
                </div>}
                <div className="TimelineContent" id={`timeline-content-modal-${this.props.isModal}`}>
                    {this.props.loadingTimeline && <Spinner id="timeline-load-spinner" animation="border" />}
                    {timelineItems.length > 0 && timelineItems.map((item: IncidentTimelineTypes, index: number) =>
                        <div className="TimelineItemWrapper" key={item.IncidentTimelineId}>
                            {item.IncidentTimelineTypeDesc !== "activity" && <div className="TimelineItem">
                                <div className="TimelineItemBodyLeft">
                                    <div className="TimelineItemTypeMarker">
                                        {item.extension && <IconBuilder extension={item.extension} size={48} />}
                                        {item.IncidentTimelineTypeDesc === "correspondence" && <span className="material-icons">email</span>}
                                        {item.IncidentTimelineTypeDesc === "note" && <span className="material-icons">chat</span>}
                                        {item.IncidentTimelineTypeDesc === "event" && <span className="material-icons">event</span>}
                                        {item.IncidentTimelineTypeDesc === "form" && <span className="material-icons">dynamic_feed</span>}
                                    </div>
                                    <div className="TimelineItemDescription">
                                        <div className="TimelineItemDescriptionUpper" onClick={() => this.toggleOpenTimelineItem(item)}>
                                            <p className="TimelineItemDescriptionUpperDate">{moment.utc(item.TimelineDateUtc).utcOffset(offset).format(this.props.timeFormat) || "*NA*"}</p>
                                            <p className="TimelineItemDescriptionUpperTitle">{item.TimelineTitle}</p>
                                        </div>
                                        <div className="TimelineItemLower">
                                            <p>{moment.utc(item.TimelineDateUtc).utcOffset(offset).format(this.longDateFormat) || "*NA*"} by {item.CreatedByName}</p>
                                            {item.NoteText && <OverlayTrigger delay={{ show: 0, hide: 0 }} placement="top" overlay={TimelinePopover(item.NoteText)}>
                                                <span id="timeline-item-preview-marker" className="material-icons">chat</span>
                                            </OverlayTrigger>}
                                            {/* {item.IncidentTimelineTypeDesc === "document" && <OverlayTrigger delay={{ show: 0, hide: 0 }} placement="top" overlay={TimelinePopover(item.NoteText)}>
                                                <span id="timeline-item-document-comments-marker" className="material-icons">chat</span>
                                            </OverlayTrigger>} */}
                                        </div>
                                    </div>
                                </div>
                                <div className="TimelineItemBodyRight">
                                    {/* {item.IncidentTimelineTypeDesc === "document" && <div className="TimelineItemDocumentTitle">
                                        <p>{item.TimelineTitle}</p>
                                    </div>} */}
                                    {!readOnly && <div className="TimelineItemRightControls">
                                        {/*Need API support*/}
                                        {!item.IsLocked && <OverlayTrigger delay={{ show: 0, hide: 0 }} placement="left" overlay={TimelineToolTip("Delete Timeline item")}>
                                            <span id="delete-timeline-item-btn" className="material-icons" onClick={() => this.manageState([{ key: "editIndex", value: index + "" }, { key: "delete" }])}>delete</span>
                                        </OverlayTrigger>}
                                        {!item.IsLocked && !item.extension && <OverlayTrigger delay={{ show: 0, hide: 0 }} placement="left" overlay={TimelineToolTip("Edit Timeline item")}>
                                            <span id="edit-timeline-item-btn" className="material-icons" onClick={() => this.manageState([{ key: "editIndex", value: index + "" }, { key: "edit" }])}>edit</span>
                                        </OverlayTrigger>}
                                        {!item.IsLocked && item.extension && <OverlayTrigger delay={{ show: 0, hide: 0 }} placement="left" overlay={TimelineToolTip("Edit Timeline item")}>
                                            <span id="edit-timeline-item-btn" className="material-icons" onClick={() => this.manageState([{ key: "editIndex", value: index + "" }, { key: "edit" }])}>edit</span>
                                        </OverlayTrigger>}
                                        {/* {!item.IsLocked && <OverlayTrigger delay={{ show: 0, hide: 0 }} placement="left" overlay={TimelineToolTip("Expand Timeline item")}>
                                            <span id="expand-timeline-item-btn" className="material-icons" onClick={() => this.toggleOpenTimelineItem(item)}>open_in_full</span>
                                        </OverlayTrigger>} */}
                                        {item.IsLocked && <OverlayTrigger delay={{ show: 0, hide: 0 }} placement="left" overlay={TimelineToolTip("Timeline item locked")}>
                                            <span id="timeline-item-locked-marker" className="material-icons">lock</span>
                                        </OverlayTrigger>}
                                    </div>}
                                </div>
                            </div>}
                            {this.state.showActivity && item.IncidentTimelineTypeDesc === "activity" && <div className="TimelineItemActivity" key={item.IncidentTimelineId}>
                                <div className="TimelineActivityBodyLeft">
                                    <span className="material-icons">timeline</span>
                                </div>
                                <div className="TimelineActivityBodyRight">
                                    <div className="TimelineActivityBodyRightUpper">
                                        <p className="TimelineActivityBodyRightUpperDate">{moment.utc(item.TimelineDateUtc).format(this.props.timeFormat) || "*NA*"}</p>
                                        <p className="TimelineActivityBodyRightUpperType">{item.IncidentTimelineTypeDesc}</p>
                                    </div>
                                    {item.NoteText}
                                </div>
                            </div>}
                        </div>)}
                    {timelineItems.length === 0 && <div className="IncidentTimelineFooter">
                        <div className="IncidentTimelineFooterTextWrapper">
                            <p>No timeline items yet.</p>
                            <p>Use the buttons above to add to the incident's timeline.</p>
                        </div>
                    </div>}
                </div>
                {this.state.uploadDocument &&
                    <DocUploader
                        manageParentState={this.manageState}
                        timelineId={this.props.WorkersCompensationIncidentId}
                        contextUserId={this.props.contextUser}
                        refreshTimeline={this.props.refreshTimeline}
                        timelineEndpoint={"/api/workComp/addOrUpdateIncidentTimelinePost"}
                        timelineType={"workComp"}
                        storageLocation={this.storageLocation}
                        containerName={this.containerName}
                        fileStoreLocationId={this.fileStoreLocationId}

                    />}
                {this.state.addEvent && <IncidentTimelineTextEditor
                    IncidentTimelineTypeId={this.state.IncidentTimelineTypeId}
                    WorkersCompensationIncidentId={this.props.WorkersCompensationIncidentId}
                    userId={this.props.contextUser}
                    toggleTextEditor={this.manageState}
                    refreshTimeline={this.props.refreshTimeline}
                />}
                {this.state.edit && <IncidentTimelineTextEditor
                    IncidentTimelineTypeId={timelineItems[parseInt(this.state.editIndex)].IncidentTimelineTypeId}
                    WorkersCompensationIncidentId={this.props.WorkersCompensationIncidentId}
                    userId={this.props.contextUser}
                    toggleTextEditor={this.manageState}
                    refreshTimeline={this.props.refreshTimeline}
                    IncidentTimelineId={timelineItems[parseInt(this.state.editIndex)].IncidentTimelineId}
                    item={timelineItems[parseInt(this.state.editIndex)]}
                />}
                {/*@ts-ignore*/}
                {openItem && openItem.extension && <DocViewer
                    //@ts-ignore
                    extension={openItem.extension}
                    //@ts-ignore
                    fileName={openItem.FileName}
                    toggleDocViewer={this.toggleOpenTimelineItem}
                    getFileTitle={this.getFileTitle}
                    //@ts-ignore
                    displayName={openItem.TimelineTitle}
                    containerName={this.containerName}
                    storageLocation={this.storageLocation}
                />}
                {this.state.delete && <DeleteIncidentTimelineItem
                    incidentTimelineItem={timelineItems[parseInt(this.state.editIndex)]}
                    toggleDelete={() => this.manageState([{ key: "delete" }, { key: "editIndex", value: -1 }])}
                    deleteIcidentTimelineItem={this.props.updateTimeLineItems}
                    contextUserId={this.props.contextUser}
                />}
                {/*@ts-ignore*/}
                {openItem && !openItem.extension &&
                    <TimelineViewer
                        openItem={openItem}
                        toggleIncidentTimelineViewer={this.toggleOpenTimelineItem}
                    />}
            </div>
        )
    }
}

export default IncidentTimeline